import cc from 'classcat';
import css from './Review.module.scss';
import Rating from '../../Rating';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Loading = function Loading() {
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    "aria-busy": "true",
    children: [/*#__PURE__*/_jsx("div", {
      className: cc([css.stats, css.loading]),
      children: "\xA0"
    }), /*#__PURE__*/_jsxs("div", {
      className: css.review,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.rating,
        children: /*#__PURE__*/_jsx(Rating, {
          count: 5,
          size: 16
        })
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.date, css.loading]),
        children: "\xA0"
      }), /*#__PURE__*/_jsx("div", {
        className: cc([css.body, css.loading]),
        children: "\xA0"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.image, css.hidden]),
      "aria-hidden": "true"
    })]
  });
};

export default Loading;